import React, { FC, ReactNode } from 'react';
import cardValidator from 'card-validator';

import { formatter } from 'helpers';
import { useLang } from 'hooks';
import { InputProps } from 'types/components';

import {
  AmericanExpressCard,
  DinersClubCard,
  DiscoverCard,
  EloCard,
  JsbCard,
  MaestroCard,
  MastercardCard,
  UnionPayCard,
  UnknownCard,
  VisaCard,
} from 'components/icons';

import Input from '.';

enum Provider {
  UNKNOWN = 'unknown',
  AMERICAN_EXPRESS = 'american-express',
  DINERS_CLUB = 'diners-club',
  DISCOVER = 'discover',
  ELO = 'elo',
  JCB = 'jcb',
  MAESTRO = 'maestro',
  MASTERCARD = 'mastercard',
  UNIONPAY = 'unionpay',
  VISA = 'visa',
}

const icon: Record<Provider, ReactNode> = {
  [Provider.UNKNOWN]: <UnknownCard />,
  [Provider.VISA]: <VisaCard />,
  [Provider.MASTERCARD]: <MastercardCard />,
  [Provider.AMERICAN_EXPRESS]: <AmericanExpressCard />,
  [Provider.DINERS_CLUB]: <DinersClubCard />,
  [Provider.DISCOVER]: <DiscoverCard />,
  [Provider.JCB]: <JsbCard />,
  [Provider.UNIONPAY]: <UnionPayCard />,
  [Provider.MAESTRO]: <MaestroCard />,
  [Provider.ELO]: <EloCard />,
};

const formatValue = (value: string) => formatter.formatCardNumber(value);

const CardNumberInput: FC<InputProps> = ({
  value,
  placeholder,
  onChange,
  ...props
}) => {
  const lang = useLang();

  const handleChange: InputProps['onChange'] = (event) => {
    event.target.value = formatValue(event.target.value);

    onChange?.(event);
  };

  const provider = cardValidator.number(value).card?.type as Provider;

  return (
    <Input
      value={value && formatValue(value as string)}
      placeholder={placeholder ?? lang.get('common.form.cardNumber.placeholder')}
      prefix={icon[provider] ?? icon[Provider.UNKNOWN]}
      onChange={handleChange}
      {...props}
    />
  );
};

export default CardNumberInput;
